const getVbaToken = (): Promise<string | null> => {
  return new Promise(resolve => {
    if (window.VAAP) {
      window.VAAP.getToken(token => {
        resolve(token);
      });
    } else {
      resolve(null);
    }
  });
};

export default getVbaToken;
